import type { IconGlyph } from '../icon';

/**
 * Tractie `chevron-down` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1 — `dist/jsx/m/chevron-down.jsx`.
 */
export const iconChevronDown: IconGlyph = {
  name: 'chevron-down',
  path: 'M18.84 8.14a.513.513 0 0 0-.71 0l-6.14 6.4-6.14-6.4a.504.504 0 0 0-.86.36c0 .13.05.25.14.35L12 16l6.86-7.15c.19-.2.18-.52-.02-.71',
};
